import React from "react";
import { Container } from "react-bootstrap";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import BackIcon from "../../../../assets/svg/BackIcon";

import Header from "../../../../containers/Header";

import Offer3Banner from "../../../../assets/images/banner/banner3.png"
import { useNavigate } from "react-router-dom";

const Offer3 = ({ isAuth }) => {
  const navigate = useNavigate();
  
  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main" id="profile_page">
        <Container>
          <div className="pagesHeading">
            <h2 className="sectionTitle border-0">Offer 3</h2>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>


          <div className="PromotionContentSection">
            <div className="PromtoionBanner">
              <img src={Offer3Banner} alt="offer" />
            </div>
            <div className="PromtoionContent">
              
              <p>Join Now <a href="https://winfix.short.gy/winfix.vip_offer3">https://winfix.short.gy/winfix.vip_offer3</a></p>
              <h4>100% Lossback Bonus on 1st deposit upto INR 25,000</h4>
              <p>🎮 Enjoy the ultimate thrill – where every second counts and every move can make you rich!</p>
              <table className="table">
                <thead>
                  <tr>
                    <th>Game Offers</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>🎮 Games Included</th>
                    <td>Aviator, Mine, Jet X, Crazy Time</td>
                  </tr>
                  <tr>
                    <th>💰 Minimum Deposit</th>
                    <td>INR 100</td>
                  </tr>
                  <tr>
                    <th>💰 Maximum Bonus Amount</th>
                    <td>INR 25,000</td>
                  </tr>
                  <tr>
                    <th>🎯 Bonus Ratio (%)</th>
                    <td>100%</td>
                  </tr>
                  <tr>
                    <th>🔁 Turnover Requirement</th>
                    <td>25X</td>
                  </tr>
                </tbody>
              </table>

              <div className="Terms">
                <h4>Terms & Conditions</h4>
                <p>
                  * The promotion is available only for first-time depositors.
                </p>
                <p><b>* The promotion is only applicable to selected users.</b></p>
                <p>
                  * The Bonus is locked in the Bonus wallet until the turnover requirement is fulfilled.
                </p>
                <p>
                  * The turnover requirement for this promotion is 25x of deposit + bonus amount and is   applicable only on Aviator, Crazy Time, Mines and JetX games.
                </p>
                <p>* Bonus will be provided in 25 equal parts.</p>
                <p>* This bonus is not applicable on any sports or any other casino games.</p>
                <p>* You can check your turnover status in Bonus section.</p>
                <p>* Post completion of each turnover part requirements, the Bonus amount will be released in your Cash wallet and can be withdrawn.</p>
                <p>* Multiple accounts will not be considered for this promotion. All players will be subject to duplicate checking. Winfix reserves the right to disqualify players if collusion or any foul play takes place in the promotion.</p>
                <p>* Winfix General Terms & Conditions apply.</p>
                
            


                <p>Check the Examples below:-</p>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Examples</th>
                      <th>Deposit Amount</th>
                      <th>Max Bonus</th>
                      <th>Turnover Required</th>
                      <th>Bonus Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>Example 1</th>
                      <td>INR 20,000</td>
                      <td>INR 20,000</td>
                      <td>INR 40,000 for each part</td>
                      <td>INR 800 for each part</td>
                    </tr>
                    <tr>
                      <th>Example 2</th>
                      <td>INR 3,000</td>
                      <td>INR 3,000</td>
                      <td>INR 6,000 for each part</td>
                      <td>INR 120 for each part</td>
                    </tr>
                    <tr>
                      <th>Example 3</th>
                      <td>INR 40,000</td>
                      <td>INR 25,000</td>
                      <td>INR 50,000 for each part</td>
                      <td>INR 1,000 for each part</td>
                    </tr>
                   
                  </tbody>
                </table>
              </div>
            </div>
            
          </div>
         
         
        </Container>
      </main>
    </>
  );
};

export default Offer3;
